<script>
import ReportingApi from "@/services/reporting-api";
import CustomersApi from "@/services/customers-api";
import CountriesApi from "@/services/countries-api";

export default {
  name: "ProductTypeChart",
  props: {
    firstDay: { type: String, default: null },
    lastDay: { type: String, default: null },
    customerCategory: { type: Number, required: true },
  },
  data() {
    return {
      chartSeries: [],
      chartOptions: {
        chart: { toolbar: { show: false } },
        colors: [
            '#f46a6a',
            '#2a2c74',
            '#34c38f',
            '#f1b44c',
            '#50a5f1'
            ],
        legend: {
            show: false,
        },
        dataLabels: { enabled: false },
        tooltip: {
          y: {
            formatter: function (val) {
              return (Math.round(val * 100) / 100).toFixed(2) + '%'
            }
          }
        }
      },
      result: {},
      labels: [],
      loaded: false,
      customersList:[],
      selectedCustomer:null,
      selectedCountry:null,
      selectedCity:null,
      citiesList:[],
      countriesList:[],
      start: this.firstDay || null,
      end: this.lastDay || null,
      total: 0
    };
  },
  mounted() {
    this.getCustomers()
    this.getCountries()
    this.fetch();
  },
  computed: {
    colors() {
        return this.chartOptions.colors;
    }
  },
  watch: {
    firstDay: 'fetch',
    lastDay: 'fetch',
    customerCategory: 'fetch',
    selectedCustomer: 'fetch',
    start: function(){ if((this.start && this.end) || (!this.start && !this.end)) this.fetch() },
    end: function(){ if((this.start && this.end) || (!this.start && !this.end)) this.fetch() },


     selectedCountry: function(){
        this.fetch()
        this.getCustomers()
        if(this.selectedCountry != null){
        this.getCities()
        }else{
        this.selectedCity=null
        this.citiesList=[]
        }
    },
    selectedCity: function(){
        this.getCustomers()
        if(this.selectedCountry!=null){
            this.fetch()
        }
    },

  },
  methods: {
    fetch() {
      this.loaded = false;
      ReportingApi.findProductTypeChart(
        this.customerCategory,
        this.start || this.firstDay,
        this.end || this.lastDay,
        this.selectedCountry==null ? null : this.selectedCountry.id,
        this.selectedCity==null ? null : this.selectedCity.id,
        this.selectedCustomer==null ? null : this.selectedCustomer.id
      ).then((item) => {
        if (item) {
          const values = (item && item.values) ? item.values : [];
          const percents = (item && item.percents && item.percents.length) ? item.percents : this.valuesToPercents(values);
          this.chartSeries = percents.map(p => Math.round(p * 100) / 100);
          this.labels = (item && item.labels) ? item.labels : [];
          this.total = (item && item.total) ? item.total : 0;
          this.result = item;
        } else {
          this.chartSeries = [];
          this.labels = [];
        }
      }).finally(() => {
        this.loaded = true;
      });
    },

    getCustomers(){

      if (this.customerCategory != null) {
              CustomersApi.getCustomersByCategory(this.selectedCountry==null ? null : this.selectedCountry.id, 
                  this.selectedCity==null ? null : this.selectedCity.id,
                  this.customerCategory).then(
                    response => {
                      this.customersList=response;
                    })

        } else {

            CustomersApi.getCustomers(this.selectedCountry==null ? null : this.selectedCountry.id, 
                  this.selectedCity==null ? null : this.selectedCity.id).then(
              response => {
                this.customersList=response;
              }
            )
      }
    },

    getCountries(){
       CountriesApi.getCountries().then(
          result => {
            this.countriesList = result
        })
     },
    getCities(){
       CountriesApi.getCities(this.selectedCountry ? this.selectedCountry.id : null).then(
          result => {
            this.citiesList = result
        })
     },

    valuesToPercents(values) {
      const sum = values.reduce((a, b) => a + (b || 0), 0);
      if (sum === 0) return values.map(() => 0);
      return values.map(v => (v / sum) * 100);
    }
  }
};
</script>

<template>
  <div class="card m-2 h-100 border border-warning">
    <div class="card-body p-3">

         <h4 :class="this.customerCategory == null ? 
              'text-primary' : this.customerCategory == 1 ? 
              'text-info' : 'text-danger'" 
              class="card-title mb-2 font-size-18 font-weight-bold">

            <i :class="this.customerCategory == null ? 
              '' : this.customerCategory == 1 ? 
              'fas fa-globe-americas' : 'fas fa-map-marker-alt'" class=" mr-2"/>

                {{this.customerCategory == null ? 
              $t("reporting.supplier.quantityVolume.title") : this.customerCategory == 0 ? 
              $t("supplierHome.productTypes.titleLocal") : $t("supplierHome.productTypes.titleOffShore") }}
          </h4>

        <div class="row mt-3">
          <div class="col-xl-3 col-lg-3 col-md-12 col-sm-12 col-xs-12 pr-lg-2">
            <b-form-group label="" label-for="">
              <v-select :options="countriesList" :placeholder="$t('lists.countries.label')" label="name" v-model="selectedCountry">
                <span slot="no-options">{{$t('lists.emptyLists.label')}}</span>
              </v-select>
            </b-form-group>
          </div>
          <div class="col-xl-3 col-lg-3 col-md-12 col-sm-12 col-xs-12 pr-lg-2">
            <b-form-group label="" label-for="">
              <v-select :options="citiesList" :placeholder="$t('lists.cities.label')" label="name" v-model="selectedCity">
                <span slot="no-options">{{$t('lists.emptyLists.label')}}</span>
              </v-select>
            </b-form-group>
          </div>
          <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-xs-12 ">
            <b-form-group label="" label-for="">
              <v-select :options="customersList" :placeholder="$t('lists.customers.label')" label="companyName" v-model="selectedCustomer">
                <span slot="no-options">{{$t('lists.emptyLists.label')}}</span>
              </v-select>
            </b-form-group>
          </div>
        </div>


        <div class="row text-center" >
          <div class="col-sm-6 col-xs-12 pr-2">
            <b-form-group  label-for="">
              <b-form-datepicker
                v-model="start"
                :locale="$t('datPicker.locale')"
                :label-no-date-selected="$t('datPicker.startDate.label-no-date-selected')"
                dark
                reset-button
                close-button
                :label-reset-button="$t('datPicker.label-reset-button')"
                :label-close-button="$t('datPicker.label-close-button')"
                dropright
                hide-header
              ></b-form-datepicker>
            </b-form-group>
          </div>
          <div class="col-sm-6 col-xs-12 ">
            <b-form-group  label-for="">
              <b-form-datepicker
                v-model="end"
                :locale="$t('datPicker.locale')"
                :label-no-date-selected="$t('datPicker.endDate.label-no-date-selected')"
                dark
                reset-button
                close-button
                :label-reset-button="$t('datPicker.label-reset-button')"
                :label-close-button="$t('datPicker.label-close-button')"
                dropright                         
                hide-header
              ></b-form-datepicker>
            </b-form-group>
          </div>
        </div>


      <div v-if="loaded">

        <div class="row mt-4 ">
            <div class="col-2"/>
            <div class="col-8 text-center">
            <p class="text-center font-size-20"> {{$t("reporting.supplier.quantityVolume.label1")}} <span class="font-weight-bold"> {{$t("reporting.supplier.quantityVolume.labelBold")}} </span> {{$t("reporting.supplier.quantityVolume.label2")}} : </p>
            </div>
            <div class="col-2"/>
        </div>
        <div class="row ">
            <div class="col-2"></div>
            <div class="col-8 text-center">
            <h3 class="text-success">{{this.total}} {{$t("reporting.supplier.quantityVolume.unit")}} </h3>

            </div>
            <div class="col-2"></div>

        </div>


        <apexchart
            v-if="chartSeries && chartSeries.length"
            type="pie"
            :series="chartSeries"
            :options="Object.assign({}, chartOptions, { labels: labels })"
            height="280"
            ></apexchart>
            <div v-else class="text-muted">{{ $t('lists.emptyLists.label') }}</div>
        </div>
        <div v-else class="text-center my-2">
            <b-spinner class="m-2" variant="primary" role="status"></b-spinner>
        </div>

        <div class="text-center text-muted">
            <div class="row">
                <div
                v-for="(label, index) in result.labels"
                :key="index"
                :class="[
                    result.labels.length > 3
                    ? 'col-3'
                    : result.labels.length > 2
                    ? 'col-4'
                    : result.labels.length ==1 ? 'col-12' : 'col-6'
                ]"
                >
                    <div class="mt-4">
                        <p class="mb-2 text-truncate">
                            <i
                            class="mdi mdi-circle mr-1"
                            :style="{ color: colors[index % colors.length] }"
                            ></i>
                            {{ label }}
                        </p>

                        <h5>
                            {{ result.values[index] || 0 }} {{$t("reporting.supplier.quantityVolume.unit")}} 
                            ({{ result.percents[index] || 0 }}%)
                        </h5>
                    </div>
                </div>
            </div>
        </div>

    </div>
  </div>
</template>
